import BarChartsHorizontal from "../ComplaintCharts/HorizontalBarChart";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";

const resolution_time = async (body) => {
  try {
    const res = await axInst.post("complaints/resolution_time", body);
    const buckets = res.data.Total_Resolution_Time;
    // console.log(buckets);

    const categories = ["0-3 days", "3-7 days", "7-15 days", ">15 days"];
    const data = {
      "0-3 days": 0,
      "3-7 days": 0,
      "7-15 days": 0,
      ">15 days": 0,
    };

    buckets.forEach((bucket) => {
      const toDate = new Date(bucket.to);
      const fromDate = new Date(bucket.from);
      const daysDifference = (toDate - fromDate) / (1000 * 3600 * 24);

      if (daysDifference <= 3) {
        data["0-3 days"] += bucket.SR_NUM_COUNT;
      } else if (daysDifference <= 7) {
        data["3-7 days"] += bucket.SR_NUM_COUNT;
      } else if (daysDifference <= 15) {
        data["7-15 days"] += bucket.SR_NUM_COUNT;
      } else {
        data[">15 days"] += bucket.SR_NUM_COUNT;
      }
    });

    const keyData = categories.reverse();
    const valData = keyData.map((category) => data[category]);

    return {
      keyData,
      valData,
    };
  } catch (error) {
    console.error(error);
  }
};

export const ResolutionTime = () => {
  const { data, submitted } = useSelector((e) => e.filtersComplaint);

  const {
    data: resolution,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["resolution", submitted],
    queryFn: () => resolution_time(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  return (
    <div className="p-2 relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && resolution && (
        <div>
          <BarChartsHorizontal
            data={resolution}
            heading={"Resolution Time"}
            gradient1={"#C9D6A4"}
            gradient2={"#A5D6A4"}
          />
        </div>
      )}
    </div>
  );
};
